import { render, staticRenderFns } from "./ThemePage.vue?vue&type=template&id=50fcb37f"
import script from "./ThemePage.vue?vue&type=script&lang=js"
export * from "./ThemePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports